import { create } from "zustand";
import { persist } from "zustand/middleware";

/**
 * super lightweight store used to temporarily store oauth2 token, JUST
 * FOR ACCOUNT ACTIVATION PAGE.
 *
 * oauth2 will not be used here eventually - it's only used bc of legacy backend API.
 */

interface AccountActivationAuthStore {
  oauth2Token: string | undefined;
  setOauth2Token: (newVal: string) => void;
}

export const useAccountActivationAuthStore =
  create<AccountActivationAuthStore>()(
    persist(
      (set) => {
        return {
          oauth2Token: undefined,
          setOauth2Token: (newVal: string): void => {
            return set(() => ({ oauth2Token: newVal }));
          },
        };
      },
      {
        name: "acct-activate-storage",
      },
    ),
  );
